import { Text, TextProps } from '@bitrise/bitkit';
import React, { FunctionComponent } from 'react';

const PageTitle: FunctionComponent<TextProps> = (props) => (
  <Text {...props} breakOn="word" config="3" />
);

export default PageTitle;
